<template>
  <v-container fluid fill-height pa-0 ma-0 class="test_green">
    <v-toolbar app>
      <v-btn icon @click="$router.push({ name: 'Checkout' })">
        <v-icon v-text="'mdi-arrow-left'" />
      </v-btn>
      <v-toolbar-title>Back to checkout page</v-toolbar-title>
      <v-spacer></v-spacer>
      <Language />
      <div v-if="$store.getters.checkAuth" class="px-2">
        <ProfileCustomer />
      </div>
    </v-toolbar>
    <v-row
      class="d-flex justify-center align-center"
      style="height: calc(100vh - 64px)"
    >
      <v-col cols="auto" class="d-flex flex-column align-center">
        <h2>Processing your payment...</h2>
        <v-progress-circular
          :size="80"
          :width="10"
          color="green"
          indeterminate
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import orderMixin from "@/mixins/orderMixin";

export default {
  layout: "Public",
  middleware: "sessionCart",
  name: "PaymentProgress",
  mixins: [orderMixin],
  data: () => ({
    flatPayCheckoutData: null,
  }),
  mounted() {
    console.log("Mounted PaymentProgress component");
    // If not in Vuex, try to load from localStorage
    if (!this.flatPayCheckoutData) {
      const data = localStorage.getItem("flatPayCheckoutData");
      if (data) {
        this.flatPayCheckoutData = JSON.parse(data);
        console.log(
          "Loaded flatPayCheckoutData from localStorage:",
          this.flatPayCheckoutData
        );
      }
    }
    this.handlerQueryParams();
  },
  // beforeMount() {
  //   this.flatPayCheckoutData = this.$store.getters.flatPayCheckoutData;
  // },

  methods: {
    handlerQueryParams() {
      const queryParams = this.$route.query;
      if (queryParams && Object.keys(queryParams).length > 0) {
        console.log("Query params received:", queryParams);
        if (queryParams.status === "accept") {
          this.handleSuccess(queryParams);
        } else if (queryParams.status === "cancel") {
          this.handleFailure(queryParams);
        } else {
          console.warn("Unknown status in query params:", queryParams.status);
        }
      }
    },
    handleSuccess(queryParams) {
      console.log("Payment was successful!", queryParams);
      console.log("FlatPayCheckoutData:", this.flatPayCheckoutData);
      const isNewFlatPayMethod = localStorage.getItem("isNewFlatPayMethod");
      if (isNewFlatPayMethod) {
        const checkoutData =
          this.$store.getters.flatPayCheckoutData.checkoutData;
        checkoutData.paymentProviderPaymentId = queryParams.payment_method;
        checkoutData.paymentProviderCustomerId = queryParams.customer;
        this.handlerCompleteOrder(checkoutData, queryParams.invoice);
      } else {
        this.handlerCompleteOrder(
          this.flatPayCheckoutData.checkoutData,
          queryParams.invoice
        );
      }
      // Additional success handling
    },
    handleFailure(data) {
      console.log("Payment failed!", data);
      this.$router.push({ name: "Checkout" });
      // Additional failure handling
    },
  },
};
</script>

<style lang="scss" scoped>
#custom-button {
  height: 30px;
  outline: 1px solid grey;
  background-color: green;
  padding: 5px;
  color: white;
}

.header {
  height: 90px;
  width: 100%;
}
</style>
